import { type EnumContainerActionRequest } from '@Model';
import { type Dispatch, type SetStateAction, useCallback } from 'react';
import { type ContainerPlanning } from './useContainerPlanning';

/** Plans an action and opens the card once the draft took it; a refused plan leaves the card as it is. */
// @ai-generated 2026-10-26T09:50:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function usePlanAndOpen(
    planning: ContainerPlanning,
    beforePlan: () => void,
    setOpened: Dispatch<SetStateAction<boolean>>,
) {
    return useCallback(
        async (action: EnumContainerActionRequest) => {
            beforePlan();
            if (await planning.plan(action)) {
                setOpened(true);
            }
        },
        [planning, beforePlan, setOpened],
    );
}
